import gql from 'graphql-tag';
import HelperGraphql from "utils/helper-graphql";

const fields = {
	'guid': 'String',
	'name': 'String',
	'description': 'String',
	'show_invitees': 'String',
	'active': 'String',
};

export default gql(`
	mutation employee_booking_invitation( ${ HelperGraphql.createFields( fields ) } ) {
	    employee_booking_invitation( ${ HelperGraphql.createVariables( fields ) } ) {
	        guid
	        name
	        description
	        show_invitees
	        active
	    }
	}
`);

